import { GraphSchema } from '@camelot/server';
import { Mission } from '@camelot/services';
import { User } from '@camelot/user';

import { CalendarEntry, calendarEntryProps } from './calendar-entry';

export interface CalendarVisitEvent extends CalendarEntry {
  userId: string;
  user?: User;
  missionId: string;
  mission?: Mission;
  status: VisitStatus;
}

export enum VisitStatus {
  Unknown = 0,
  Draft = 1,
  WaitingForClientApproval = 2,
  Planned = 3,
  Done = 4,
  Canceled = 5,
}

const props: (keyof CalendarVisitEvent)[] = ['missionId', 'mission', 'status', 'userId', 'user'];

export const calendarVisitEventProps = new GraphSchema<CalendarVisitEvent>(props.concat(calendarEntryProps));
